import styles from './footerNav.module.scss';

const FooterNav = () => {
  return (
    <>
      <footer className={styles.footerWrap}>
        <div className={styles.footer}>
          <div className={styles.footerChild} />
          <div className={styles.hippocratDaoFoundation}>
            ⓒ 2023 Hippocrat DAO Foundation. All rights reserved.
          </div>
          <img className={styles.icon} alt="" src="/footer/11111-2@2x.png" />
          <div className={styles.footerItem} />
          <img className={styles.icon1} alt="" src="/footer/--2@2x.png" />
          <img className={styles.icon2} alt="" src="/footer/--1@2x.png" />
        </div>
      </footer>
    </>
  );
};

export default FooterNav;
